import { Form, Input } from "decorator-form";
import { css } from "styled-components";

import InputType from "common/form/InputType";
import SubFormWidget from "common/form/widgets/SubFormWidget";

/**
 * @author chills
 * @description reusable config for basic block styles. See {@link SubFormWidget}
 */

@Form({title: "Column Header Styles"})
export class ColumnHeaderStylesConfig {

	@Input({type: InputType.COLOR, title: "Background Color"})
	public backgroundColor?: string;

	@Input({type: InputType.COLOR, title: "Text Color"})
	public color?: string;

	@Input({type: InputType.BORDER, title: "Border"})
	public border?: string;

	@Input({type: InputType.PADDING, title: "Padding"})
	public padding?: string;

	@Input({type: InputType.MARGIN, title: "Margin"})
	public margin?: string;
}

// use this as your input type
export const columnHeaderStylesInput = SubFormWidget.registerForm(ColumnHeaderStylesConfig);

// convert to TemplateStringArray for styled-components
export function toBlockCss(data: ColumnHeaderStylesConfig) {
	return data ? css`
		background-color: ${data.backgroundColor};
		color: ${data.color};
		border: ${data.border};
		padding: ${data.padding};
		margin: ${data.margin};
	` : undefined;
}



// WEBPACK FOOTER //
// ./src/common/views/columnHeader/ColumnHeaderStylesConfig.ts